/* eslint-disable */
export default {
  recentActivities: 'Atividades recentes',
  text: 'SMS',
  fax: 'Fax',
  voicemail: 'Correio de voz',
  call: 'Chamada',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
